import { Size } from 'react-easy-crop';

import { slate } from '@/lib/colours';
import { styled } from '@/primitives';

export const ImageDropWrapper = styled('div')<{ cropSize: Size }>`
  display: flex;
  flex-direction: column;
  background-color: ${slate[50]};
  width: 100%;
  flex: 1;
  min-height: 0;
  align-items: stretch;
  border-radius: 16px;
`;

export const PreviewImageWrapper = styled('div')<{ cropSize: Size }>`
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 300px;
`;

export const ZoomControlWrapper = styled('div')<{ width: number }>`
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
`;

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
